"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Dumbbell, Truck, Heart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const competencies = [{
  title: "We make you stronger and grow bigger muscles",
  description: "We customise 1-on-1 or 2-on-1 programs. Train with your partner or buddy at a discount!",
  icon: Dumbbell,
  href: "#how-we-roll"
}, {
  title: "We help you lose stubborn fat",
  description: "You'd be surprised at how much you didn't know about nutrition. Let our experts guide you.",
  icon: Truck,
  href: "#how-we-roll"
}, {
  title: "We develop your functional fitness so you're doing everything you physically want, well into your old age.",
  description: "Investing in yourself now makes the difference on whether you move well into your 70s and 80s, or are stuck in a wheelchair.",
  icon: Heart,
  href: "#how-we-roll"
}];
export default function OurCoreCompetencies() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222632" id="how-we-roll" className="bg-secondary/30 py-24 md:py-32 relative overflow-hidden" ref={sectionRef}>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_70%)] opacity-10 pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className={`max-w-3xl mb-16 md:mb-24 transition-all duration-1000 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-5xl md:text-7xl font-bold tracking-normal text-foreground mb-6 uppercase">
            WHAT WE <span className="text-primary">DO</span>
          </h2>
          <p className="text-xl font-default max-w-2xl leading-relaxed text-accent-foreground">To "send it" is to commit 100%, with no hesitation. We're dedicated to sending it in everything we do. <br /><br />We take fitness seriously, so you can take life less seriously.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {competencies.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="group h-full flex flex-col bg-card border-t-4 border-t-primary border-x-transparent border-b-transparent hover:scale-105 transition-all duration-500 overflow-hidden relative rounded-xl shadow-md hover:shadow-2xl">
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4 pt-6 text-center flex flex-col items-center">
                    <div className="mb-4 p-3 bg-secondary/20 rounded-lg w-fit text-primary group-hover:rotate-12 transition-transform duration-500 ease-out">
                      <Icon size={48} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="leading-none font-medium tracking-normal text-foreground group-hover:text-primary transition-colors duration-300 !text-2xl italic font-['Heritage_Script']">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="flex-grow pb-4 text-center">
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className={`flex justify-center mt-12 transition-all duration-1000 delay-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="https://wa.me/6588990728" className="group relative inline-flex items-center justify-center px-8 py-4 font-header text-xl font-bold uppercase tracking-wider text-primary-foreground bg-primary border-2 border-foreground rounded-lg transition-all duration-200 hover:-translate-y-1 hover:translate-x-[-1px] hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] active:translate-y-0 active:translate-x-0 active:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]">
            Sounds good
            <svg viewBox="0 0 24 24" fill="none" className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true">
              <path d="M21 11.5C21 16.1944 17.1944 20 12.5 20C11.5227 20 10.5893 19.8354 9.7217 19.5321L4 22L5.65685 17.3431C4.61464 15.8417 4 14.0194 4 12.05C4 7.35558 7.80558 3.55 12.5 3.55C17.1944 3.55 21 7.35558 21 11.5Z" stroke="#F2E4D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9 10.5C9 10.5 10 9.5 11.5 9.5C13 9.5 14.5 11 14.5 12.5C14.5 14 13.5 15 13.5 15" stroke="#F2E4D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M11 13.5C11 13.5 11.5 13 12.5 13C13.5 13 14 13.5 14 13.5" stroke="#F2E4D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </div>
    </section>;
}